export const setUnvisitedPlacesNearby = ({
  pageNumber,
  pageSize,
  placeCount,
  places,
  isLoaded,
}) => state => {
  return {
    ...state,
    unvisitedPlacesNearby: {
      ...state.unvisitedPlacesNearby,
      items: places || [],
      lastFetch: {
        failed: false,
        reason: { message: "" },
      },
      loadingUnvisitedPlacesNearby: false,
      pagination: {
        ...state.unvisitedPlacesNearby.pagination,
        currentPageNumber: pageNumber,
        currentPageSize: pageSize,
        itemCount: placeCount,
        pageCount: Math.ceil(
          placeCount / state.unvisitedPlacesNearby.pagination.pageSize,
        ),
      },
      isLoaded,
    },
  };
};
